import React from 'react';
import { KatPopoverTrigger } from '@amzn/katal-react';
import styles from './PopoverCellRenderer.module.scss';

interface CellClassParams {
  value: any;
  data: any;
  node: any;
  colDef: any;
  column: any;
  api: any;
  columnApi: any;
  context: any;
}

interface RowData {
  stringId: string[];
  sourceText: string;
  context: string;
  reviewComment: string;
  stringPK: string;
}

interface PopoverCellRendererProps extends CellClassParams {
  onCellClick: (
    value: string,
    nodeId: string,
    field: string,
    data: RowData
  ) => void;
}

export const PopoverCellRenderer = (props: PopoverCellRendererProps) => {
  const { value, node, colDef, data, onCellClick } = props;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onCellClick(value ?? '', node.id, colDef.field, data);
  };

  return (
    <div onClick={handleClick} className={styles.popoverCellWrapper}>
      <KatPopoverTrigger
        for="popover-column-id"
        type="click"
        className={styles.popoverCell}
      >
        <div className={styles.popoverContent}>{value || '\u00A0'}</div>
      </KatPopoverTrigger>
    </div>
  );
};
